import { useEffect, useState } from "react";
import { Screen } from "../components/Screen";
import { api } from "../api/client";
import type { InventoryCar } from "@karat/shared";

/**
 * п.4 ТЗ. Фільтри готові (модель/ціна/тип ДВЗ), але джерела складу дилера ще немає —
 * бекенд поки повертає порожній список. Показуємо чесний порожній стан замість
 * вигаданих автомобілів (п.35 ТЗ).
 */
export function Inventory() {
  const [items, setItems] = useState<InventoryCar[] | null>(null);

  useEffect(() => {
    api.get<InventoryCar[]>("/api/inventory").then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <Screen title="Авто в наявності" subtitle="Конкретні автомобілі на складі дилера" showBack>
      {items === null && <div className="loading-row">Завантаження…</div>}
      {items && items.length === 0 && (
        <div className="empty-state">
          <div className="empty-state-icon">📦</div>
          Дані складу оновлюються.
          <br />
          Найближчим часом тут з'являться конкретні автомобілі в наявності — а поки що
          перегляньте модельний ряд нових Toyota або зверніться до консультанта.
        </div>
      )}
    </Screen>
  );
}
